import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import AuthService from "./accountAuth";

const RequireCustomerAuth = ({ children }: { children: ReactElement }) => {
  const token = AuthService.getAuthToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequireCustomerAuth;
